import React from 'react';
import { ModeToggle } from '@/components/mode-toggle';
import { BilderitLogoHorizontal } from '@/components/BilderitLogoHorizontal';

export type EmptyLayoutProps = {
  noLogo?: boolean;
  children?: React.ReactNode;
};

const EmptyLayout: React.FC<EmptyLayoutProps> = ({
  noLogo = false,
  children,
}) => (
  <main className="flex w-full h-full p-0 m-0 overflow-x-hidden">
    <div className="inline-flex flex-col grow w-full min-h-screen p-0 m-0">
      <div className="flex flex-row w-full h-16 shrink-0 items-center gap-2 sticky bg-background top-0 z-10">
        {!noLogo && (
          <BilderitLogoHorizontal
            style={{ height: '2.5rem', margin: '15px', position: 'absolute' }}
          />
        )}
        <div className="absolute top-4 right-4">
          <ModeToggle />
        </div>
      </div>
      {children}
    </div>
  </main>
);

export const EmptyLayoutNoLogo: React.FC = (props) => (
  <EmptyLayout {...props} noLogo={true} />
);

export default EmptyLayout;
